import { PROJECTS } from "../data/experienceData";

export const getGapMargin = (project) => {
  switch (true) {
    case PROJECTS["Passion.io"] === project:
      return 0;
    case PROJECTS["appt-now"] === project:
      return 0;
    case PROJECTS.Chekin === project:
      return 0;
    case PROJECTS.Diggity === project:
      return 0;
    case PROJECTS.Sharekey === project:
      return 0;
    default:
      return 0;
  }
};

export const lastMargin = 0;
